import { mapEnumToOptions } from '@abp/ng.core';

export enum FormPriority {
  Low = 0,
  Medium = 1,
  High = 2,
  VeryHigh = 3,
}

export const formPriorityOptions = mapEnumToOptions(FormPriority);
